import {
  REQUEST_LOADING,
  REQUEST_FAILURE,
  REQUEST_SUCCESS,
  RESET_REQUEST_STATE,
  OPEN_KNOWLEDGE_CENTER,
  CLOSE_KNOWLEDGE_CENTER,
  KNOWLEDGE_CENTER_STATE_KEY,
} from "../actionTypes";

export const setRequestLoading = (payload: any, key: string) => ({
  type: REQUEST_LOADING,
  key,
  payload,
});
export const setRequestError = (payload: any, key: string) => ({
  type: REQUEST_FAILURE,
  key,
  payload,
});
export const setRequestSuccess = (payload: any, key: string) => ({
  type: REQUEST_SUCCESS,
  key,
  payload,
});

// Action to reset/clear specific request state keys
export const resetRequestState = (keys: string[]) => ({
  type: RESET_REQUEST_STATE,
  payload: keys,
});

export const openKnowledgeCenter = (metricData: any, key: string = KNOWLEDGE_CENTER_STATE_KEY) => ({
  type: OPEN_KNOWLEDGE_CENTER,
  key,
  payload: {
    isOpen: true,
    metricData: metricData || {},
  },
});

export const closeKnowledgeCenter = (key: string = KNOWLEDGE_CENTER_STATE_KEY) => ({
  type: CLOSE_KNOWLEDGE_CENTER,
  key,
  payload: {
    isOpen: false,
    metricData: {},
  },
});
